export default "__VITE_ASSET__zbIWs5HK__"